<template>
  <ion-card class="product-card ion-text-center" :color="isFeatured ? 'primary' : ''" :router-link="{
    name: 'ProductDetailPage',
    params: { id: product.id, ...extraRouterParams }
  }" button>
    <ion-badge v-if="product.sellingPrice < product.price" class="sale-badge" color="danger">
      {{ t('sale') }}
    </ion-badge>
    <img class="featured-product-img" :src="product.imageLink" v-if="isFeatured" />
    <img class="product-img" :src="product.imageLink" v-else />
    <ion-card-header class="product-header">
      <ion-card-subtitle color="dark" class="ion-text-nowrap">{{ product.title }}</ion-card-subtitle>
      <ion-card-subtitle v-if="product.sellingPrice != product.price">
        <s>HK${{ Number(product.price).toLocaleString() }}</s> HK${{ Number(product.sellingPrice).toLocaleString() }}
      </ion-card-subtitle>
      <ion-card-subtitle v-else>
        HK${{ Number(product.sellingPrice).toLocaleString() }}
      </ion-card-subtitle>
    </ion-card-header>
    <!--<p class="ion-text-nowrap">{{ product.description }}</p>-->
    <ion-buttons class="product-actions" v-if="!hideDetails && (product.relatedProductVariants || product.inStock)">
      <ion-button @click.stop="addProductToCart(product)" v-if="!product.relatedProductVariants && product.inStock">
        <ion-icon slot="icon-only" :icon="cartOutline"></ion-icon>
      </ion-button>
      <ion-button @click.stop="updateUserLikedItem(product, 'remove')" v-if="userLoggedIn && product.likedByUser">
        <ion-icon slot="icon-only" :icon="heart" color="danger"></ion-icon>
      </ion-button>
      <ion-button @click.stop="updateUserLikedItem(product, 'add')" v-if="userLoggedIn && !product.likedByUser">
        <ion-icon slot="icon-only" :icon="heartOutline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-chip v-if="!product.relatedProductVariants && !product.inStock">
      <ion-label>{{ t('soldOut') }}</ion-label>
    </ion-chip>
    <!--<ion-chip>
      <ion-label>{{ product.categoryName }}</ion-label>
    </ion-chip>-->
  </ion-card>
</template>

<script lang="ts">
// icons
import { heart, heartOutline, cartOutline } from "ionicons/icons";

// components
import { IonBadge, IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonCardContent,
          IonChip, IonLabel, IonIcon, IonButtons, IonButton,
          loadingController, } from "@ionic/vue";

// API services
import ProductService from '@/services/ProductService';

// composables
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { utils } from '@/composables/utils';

export default {
  props: [
    "product",
    "hideDetails",
    "extraRouterParams",
    "userLoggedIn",
    "isFeatured",
  ],
  components: {
    IonBadge, IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonCardContent,
    IonChip, IonLabel, IonIcon, IonButtons, IonButton,
  },
  setup() {
    const store = useStore();
    const { t } = useI18n();
    const { presentToast } = utils();

    const addProductToCart = async (product: any) => {
      const loading = await loadingController.create({});
      await loading.present();
      store.dispatch('addProductToCart', { product });
      loading.dismiss();
      presentToast( t('successAddedToCart'), 2000, 'top' );
    }
    const updateUserLikedItem = async (product: any, action = 'add') => {
      const loading = await loadingController.create({});
      await loading.present();
      if (action == 'add') await ProductService.addUserLikedItem(product.id);
      else await ProductService.removeUserLikedItem(product.id);
      product.likedByUser = (action == 'add');
      loading.dismiss();
      presentToast( t('successUpdateLikedItems'), 2000, 'top' );
    }

    return {
      t,

      // icons
      cartOutline, heart, heartOutline,

      // methods
      addProductToCart, updateUserLikedItem,
    };
  },
};
</script>


<style scoped>
  .product-card {
    margin: 5px;
  }
  .product-header {
    padding: 10px;
  }
  .product-actions {
    display: block;
  }
  .featured-product-img {
    width: 100%;
    object-fit: cover;
    height: 300px;
  }
  .product-img {
    width: 100%;
    height: 110px;
    object-fit: cover;
  }
  @media only screen and (min-width: 768px) {
    .product-img {
      height: 200px;
    }
  }
</style>